import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { take, catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { MessageService } from 'src/app/services/message/message.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {

  constructor(private transferHttp: TransferHttpService,
    private auth: AuthService,
    private router: Router,
    private messageService: MessageService) { 
      const validPasswordPattern = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,100}$/;
      this.formGroup = new FormGroup({
        oldPassword: new FormControl('',{
          validators: [
            Validators.required
          ]
        }),
        password: new FormControl('',{
          validators: [
            Validators.required,
            Validators.pattern(validPasswordPattern)
          ]
        }),
        confirmPassword: new FormControl('',{
          validators: [
            Validators.required,
            Validators.pattern(validPasswordPattern)
          ]
        }),
      },)
    }

  oldPassword: string;
  password: string;
  confirmPassword: string;
  hideOldPassword: boolean = true;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;
  passwordValidationMessage = {};
  //Regex requiring at least one special character, one upper, one lower, one number and more than 8 characters, no spaces https://regex101.com/r/Z3REM0/1
  
  spinnerText: string = "Updating...";
  showSpinner: boolean = false;

  public formGroup:FormGroup;

  public resetMyPassword() {
    this.showSpinner = true;
    if (this.password == this.confirmPassword) {
      this.transferHttp.put(`User/ResetMyPassword`, { oldPassword: this.oldPassword, newPassword: this.password }).pipe(
        take(1),
        catchError(err => { return of(false); })
      )
        .subscribe(r => {
          this.oldPassword = undefined;
          this.password = undefined;
          this.confirmPassword = undefined;
          this.showSpinner = false;
          this.auth.logout().subscribe(l =>{
            this.auth.removePwdRefresh();
            this.router.navigate(['login']);
          });
        });
    }
    else {
      alert("Password and Confirm Password do not match!!!");
    }
  }
  onOldPasswordChange(value){
    this.formGroup.patchValue({
      oldPassword: value
    })
    this.validatePasswords(value);
  }
  onPasswordChange(value){
    this.formGroup.patchValue({
      password: value
    })
    this.validatePasswords(value);
  }
  onConfirmPasswordChange(value){
    this.formGroup.patchValue({
      confirmPassword: value
    })
    this.validatePasswords(value);
  }
  validatePasswords(password){
    //validate passwords are the same
    password = this.formGroup.controls.password.value;
    const confirmPassword = this.formGroup.controls.confirmPassword.value;
    const oldPassword = this.formGroup.controls.oldPassword.value;
    if(oldPassword === password){

      //password matches previous password. But they still need to press submit to check if they typed it in correctly
      this.formGroup.controls.password.setErrors({ 
        ...(this.formGroup.controls.password.errors || {}),
        contradiction: true
      });
    }
    else if (password === confirmPassword && 
      password.length > 0 && confirmPassword.length > 0 &&
      this.formGroup.controls.password.valid)
    {
      //Correct!
      this.formGroup.controls.password.setErrors(null);
      this.formGroup.controls.confirmPassword.setErrors(null);
    } else if(!this.formGroup.controls.password.valid && password === confirmPassword ) {
      //confirm technically matches, so no error
      this.formGroup.controls.confirmPassword.setErrors(null);
    }
    else{
      //Passwords don't match
      this.formGroup.controls.confirmPassword.setErrors({ mismatch: true });
    }
  }

  ngOnInit() {
    this.passwordValidationMessage = this.messageService.getUserPasswordValidationMessage();
  }

}
